import { ComponentMissionBoxes } from '@edwin-group/cj-graphql';
import { useMissionStore } from '../../../shared/store/useMissionStore';
import DefaultContentTemplateTextEditor from '@/components/DefaultContentTemplate/TextEditor';
import { ComponentCommonTextEditorWithHtml } from '@/components/DefaultContentTemplate';

export const Boxes = () => {
  const mission = useMissionStore((state) => state.mission);

  if (!mission) {
    return null;
  }

  const renderBox = (box: ComponentMissionBoxes) => {
    const headerIcon = box.traitBox ? box.trait?.icon?.url : box.headerIcon?.icon?.url;
    return (
      <div className="rounded-2xl border border-[#9FC3FA] bg-[#F6F9FF] p-4">
        <div className="flex items-center gap-sh-15">
          {headerIcon && <img src={headerIcon} alt="" className="size-[38px]" />}
          <h3 className="!mb-0 font-cadiz text-sh-28-32 font-bold">{box.title}</h3>
        </div>

        <DefaultContentTemplateTextEditor
          className="!my-sh-15 font-cadiz !text-sh-16-24"
          component={
            {
              markdownText: box.content || '',
            } as ComponentCommonTextEditorWithHtml
          }
        />
      </div>
    );
  };
  return (
    <div className="flex flex-col gap-4">
      {mission?.boxes?.map((box) => (
        <div key={box?.title}>
          {renderBox(box as ComponentMissionBoxes)}
          <div className="h-7.5" />
        </div>
      ))}
    </div>
  );
};
